Vue.component('test-1-text-display', {
    template: `
        <div style='color:red;'>The quick brown fox jumps over the lazy dog. 1234567890</div>
    `
})